<template>
  <div class="content">
    <!-- 搜索区域 -->
    <div class="search-form bgW pd10 mb10">
    <el-form :model="query" inline size="mini" label-position="：">
      <el-form-item label="创建时间" prop="create_time"  >
        <el-date-picker
          v-model="query.create_start"
          type="date"
          value-format="yyyy-MM-dd"
          class="w120"
          placeholder="开始日期"
        />
        <el-date-picker
          v-model="query.create_end"
          type="date"
          class="w120"
          value-format="yyyy-MM-dd"
          placeholder="结束日期"
        />
        </el-form-item>

        <el-form-item label="病历单号">
          <el-input v-model="query.case_no" class="w140" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="客户姓名">
          <el-input v-model="query.customer_name" class="w120" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="query.telephone" class="w140" placeholder="请输入" clearable />
        </el-form-item>

        <el-form-item label="咨询医生">
          <el-input v-model="query.doctor_name" class="w120" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="科室">
          <el-input v-model="query.department" class="w120" placeholder="请输入" clearable />
        </el-form-item>
        
        <el-form-item label="选择店铺" prop="shop_id" v-if="!userInfo.shop_id">
          <el-select v-model="query.shop_id" class="w120" placeholder="请选择" filterable clearable>
            <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="病例类型">
          <el-select v-model="query.case_type" class="w120" placeholder="全部" clearable>
            <el-option label="初诊" value="1" />
            <el-option label="复诊" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" icon="el-icon-search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="margin-bottom:10px;">
      <el-button type="primary" size="mini" icon="el-icon-download" @click="exportData">
        导出
      </el-button>
    </div>

    <div class="accountCon bgW">
      <el-table
        :data="list"
        size="small"
        border
        :cell-style="$style.cellStyle"
        :header-cell-style="$style.rowClass"
      >
        <ElTableColumn label="序号" type="index" width="55" />
        <ElTableColumn label="所属门店" prop="shop_name" />
        <ElTableColumn label="客户姓名" prop="customer_name" />
        <ElTableColumn label="手机号" prop="telephone" />
        <ElTableColumn label="咨询时间" prop="create_time" />
        <ElTableColumn label="病历ID" prop="id" />
        <ElTableColumn label="病历单号" prop="case_no" />
        <ElTableColumn label="病例类型" prop="case_type_label" />
        <ElTableColumn label="科室" prop="department" />
        <ElTableColumn label="性别" prop="customer_sex" />
        <ElTableColumn label="年龄" prop="age" >
          <template slot-scope="{ row }">
            {{ row.age  + '岁' }}
          </template>
        </ElTableColumn >
        
        <ElTableColumn label="咨询医生" prop="doctor_name" />

        <ElTableColumn label="操作" fixed="right" width="120">
          <template slot-scope="{ row }">
            <span class="theme" @click="tapBtn('checkOrder',row)">病历单</span>
            <!-- <span class="theme" @click="tapBtn('addOrder',row)" v-if="userInfo.shop_type==1 || userInfo.shop_type == 3 || userInfo.group_id == 96|| [1, 1737, 1901, 1916, 1917].includes(userInfo.id)">开单 </span> -->
            <!-- <span class="theme" @click="tapBtn('edit',row)" v-if="userInfo.shop_type==1 || userInfo.shop_type == 3|| userInfo.group_id == 96 || [1, 1737, 1901, 1916, 1917].includes(userInfo.id)"> 编辑 </span> -->
            <span class="theme" @click="tapBtn('order',row)"> 订单 </span>
          </template>
        </ElTableColumn>
      </el-table>

      <pagination
        class="page tc mt10"
        :total="page.total"
        :page.sync="page.page"
        :limit.sync="page.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import pagination from '@/components/Pagination'
import { getCustomerCaseMedicalList } from '@/api/client'
import { shopTypePerson } from "@/api/shop";
import { mapGetters } from 'vuex'

class Page {
  total = 0
  page = 1
  limit = 10
}

export default {
  name: 'ClassifyList',
  components: { pagination },
  props: {
    clienId: {
      type: String,
      default: ''
    },
    detail: {
      type: [Object, String],
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    return {
      oldId: '',
      page: new Page(),
      list: [],
      shopList: [],
      query: {
        case_no: '',
        shop_id: '',
        doctor_name: '',
        create_end: '',
        create_start: '',
        customer_name: '',
        telephone: '',
        department: '',
        case_type: '',
        order_status: ''
      }
    }
  },
  mounted() {
    this.getList()
    this.getPersonList()
  },
  methods: {
    getPersonList(){  
        shopTypePerson({action: 'shop'}).then(res => {
        this.shopList = res || [];
      })
    },
    search() {
      this.page.page = 1
      this.getList()
    },
    reset() {
      this.query = {
        case_no: '',
        customer_name: '',
        telephone: '',
        department: '',
        case_type: '',
        shop_id: '',
        doctor_name: '',
        create_end: '',
        create_start: '',
        order_status: ''
      }
      this.page.page = 1
      this.getList()
    },
    exportData(){
      const params = {
        ...this.query,
        export: 1
      }
      getCustomerCaseMedicalList(params).then(res => {
        window.open(res.data?.url || '')
      })
    },
    // 获取列表
    getList() {
      const params = {
        ...this.page,
        ...this.query
      }
      getCustomerCaseMedicalList(params).then(res => {
        this.list = res.data?.data || []
        this.page.total = res.data?.total || 0
      })
    },
    tapBtn(kind, row) {
      const query = {
        caseId: row.id,
        medical_id: row.medical_id,
        medical_title :row.medical_title,
        id: row.customer_id,
        isEdit: 'true',
        kind
      }
    
      if (kind === 'changeList') {
        this.$router.push({ name: '变更记录', query })
      } else if (kind === 'addOrder') {
        this.$router.push({
          name: '创建订单',
          query: {
            clienId: row.customer_id,
            medical_records_id: row.id,
            detail: this.detail
          }
        })
        
      } else if (kind === 'edit') {
       
        this.$router.push({ name: '新增病历', query })
      } else if (kind === 'order') {
        this.$router.push({ name: '销售出库单', query: { medical_id: row.id } })
      } else if (kind === 'checkOrder') {
        const route = this.$router.resolve({
          name: '病历预览',
          query: { medical_id: row.id }
        })
        window.open(route.href, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 10px;
}
.bgW {
  background: #fff;
  border-radius: 3px;
}
.pd10 {
  padding: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.accountCon {
  margin-top: 10px;
}
.theme {
  cursor: pointer;
  margin: 0 5px;
}
</style>